<template>
  <div>
    <div class="contents">
      <b-form @submit="onSubmit" class="row row-cols-2 row-cols-lg-5 g-2 mb-5">
        <div class="col-lg-2">
          <select aria-label="" v-model="searchData.pagesize">
            <option value="10" selected>
              {{ $t("filter.common.sort_by_10") }}
            </option>
            <option value="50">{{ $t("filter.common.sort_by_50") }}</option>
            <option value="100">
              {{ $t("filter.common.sort_by_100") }}
            </option>
          </select>
        </div>

        <div class="col-lg-2">
          <select v-model="searchData.hc_status">
            <option value="disabled" disabled>
              {{ $t("title.common.handicap") }}&nbsp;
              {{ $t("title.common.status") }}
            </option>
            <option value="">{{ $t("filter.common.total") }}</option>
            <option value="-1">{{ $t("filter.common.none") }}</option>
            <!-- <option value="0">{{ $t("filter.common.ready") }}</option> -->
            <option value="1">{{ $t("filter.common.done") }}</option>
          </select>
        </div>

        <div class="col-lg-2">
          <select v-model="searchData.membertype">
            <option value="disabled" disabled>
              {{ $t("title.membership.certification") }}
            </option>

            <option value="0">{{ $t("filter.common.total") }}</option>
            <option value="1">{{ $t("filter.membership.certified") }}</option>
            <option value="2">
              {{ $t("filter.membership.uncertified") }}
            </option>
          </select>
        </div>

        <div class="col-lg-2">
          <select v-model="searchData.status">
            <option value="disabled" disabled>
              {{ $t("filter.common.status") }}
            </option>
            <option value="0">{{ $t("filter.common.total") }}</option>
            <option value="1">{{ $t("filter.membership.ok") }}</option>
            <option value="2">{{ $t("filter.membership.delete") }}</option>
          </select>
        </div>

        <div class="col-lg-2">
          <select v-model="searchData.searchtype">
            <option value="P.player_id">{{ $t("filter.common.id") }}</option>
            <option value="P.nickname">
              {{ $t("filter.common.nickname") }}
            </option>
            <option value="P.email">{{ $t("filter.common.email") }}</option>
            <option value="O.nickname">
              {{ $t("filter.common.location") }}
            </option>
          </select>
        </div>

        <div class="col-lg-2">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="searchData.searchname"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
              value=""
            ></button>
          </div>
        </div>
      </b-form>

      <table class="table board toggle-xxl">
        <thead>
          <tr>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">{{ $t("title.common.id") }}</th>
            <th class="col-auto d-sm-table-cell">
              {{ $t("title.common.nickname") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.common.handicap") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.email") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.membership.certification") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.membership.gender") }}
            </th>
            <th class="col-auto d-none d-md-table-cell">
              {{ $t("title.membership.favorite_location") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.registration") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.status") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.handicap") }}&nbsp;{{
                $t("title.common.status")
              }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.playerinfo.no }}
              </td>
              <td class="col-auto text-start text-sm-center">
                <router-link
                  :to="{
                    name: 'MemberView',
                    params: { playerno: item.playerinfo.playerno },
                  }"
                  class="more"
                >
                  {{ item.playerinfo.id }}
                </router-link>
              </td>
              <td class="col-auto d-sm-table-cell text-start">
                <MemberInfo
                  :nickname="item.playerinfo.nickname"
                  :playerno="item.playerinfo.playerno"
                  :displayText="item.playerinfo.nickname"
                  :member_img="item.playerinfo.member_img"
                  :badge_img="item.playerinfo.badge_img"
                />
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                <router-link
                  :to="{
                    name: 'HandiList',
                    query: { searchname: item.playerinfo.nickname },
                  }"
                  class="more"
                >
                  {{ hc_au(item.playerinfo.handicap_index) }}
                </router-link>
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.playerinfo.email }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{
                  item.playerinfo.membertype === "1"
                    ? $t("filter.membership.certified")
                    : $t("filter.membership.uncertified")
                }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{
                  item.playerinfo.gender === "M"
                    ? $t("filter.common.male")
                    : $t("filter.common.female")
                }}
              </td>
              <td class="col-auto d-none d-md-table-cell">
                <span class="shop-name">
                  {{ item.playerinfo.shopname }}
                </span>
              </td>
              <td class="col-auto d-none d-xxl-table-cell text-date">
                {{ item.playerinfo.timezone_regdate | dateformat }}
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                <label
                  :class="{
                    'status-done px-2': item.playerinfo.status === '1',
                    'status-drop px-2': item.playerinfo.status === '2',
                  }"
                >
                  {{ item.playerinfo.status === "1" ? "O" : "X" }}
                </label>
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                <label
                  class="px-2"
                  :class="[
                    item.playerinfo.hc_status === '1'
                      ? 'status-done'
                      : item.playerinfo.hc_status === '0' &&
                        item.playerinfo.score_pk !== null
                      ? 'status-standby'
                      : 'status-none',
                  ]"
                  @click="get_modal_handicap(item.playerinfo.playerno)"
                >
                  <span class="pointer">
                    {{
                      item.playerinfo.hc_status === "1"
                        ? $t("filter.common.done")
                        : item.playerinfo.hc_status === "0" &&
                          item.playerinfo.score_pk !== null
                        ? $t("filter.common.ready")
                        : $t("filter.common.none")
                    }}
                  </span>
                </label>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="9">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.number") }}
                    </div>
                    <div class="col-8">{{ item.playerinfo.no }}</div>
                  </div>

                  <div class="row d-sm-none">
                    <div class="col-4">
                      {{ $t("title.common.handicap") }}
                    </div>
                    <div class="col-8">
                      <router-link
                        :to="{
                          name: 'HandiList',
                          query: { searchname: item.playerinfo.nickname },
                        }"
                        class="more"
                      >
                        {{ hc_au(item.playerinfo.handicap_index) }}
                      </router-link>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.email") }}
                    </div>
                    <div class="col-8">
                      {{ item.playerinfo.email }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.membership.certification") }}
                    </div>
                    <div class="col-8">
                      {{
                        item.playerinfo.membertype === "1"
                          ? $t("filter.membership.certified")
                          : $t("filter.membership.uncertified")
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.membership.gender") }}
                    </div>
                    <div class="col-8">
                      {{
                        item.playerinfo.gender === "M"
                          ? $t("filter.common.male")
                          : $t("filter.common.female")
                      }}
                    </div>
                  </div>
                  <div class="row d-md-none">
                    <div class="col-4">
                      {{ $t("title.membership.favorite_location") }}
                    </div>
                    <div class="col-8 shop-name">
                      {{ item.playerinfo.shopname }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.registration") }}
                    </div>
                    <div class="col-8 text-date">
                      {{ item.playerinfo.timezone_regdate | dateformat }}
                    </div>
                  </div>
                  <div class="row d-xl-none">
                    <div class="col-4">
                      {{ $t("title.common.status") }}
                    </div>
                    <div class="col-8">
                      <label
                        :class="{
                          'status-done px-2': item.playerinfo.status === '1',
                          'status-drop px-2': item.playerinfo.status === '2',
                        }"
                      >
                        {{ item.playerinfo.status === "1" ? "O" : "X" }}
                      </label>
                    </div>
                  </div>
                  <div class="row d-xl-none">
                    <div class="col-4">
                      {{ $t("title.common.handicap") }}&nbsp;
                      {{ $t("title.common.status") }}
                    </div>
                    <div class="col-8">
                      <label
                        class="px-2"
                        :class="[
                          item.playerinfo.hc_status === '1'
                            ? 'status-done'
                            : item.playerinfo.hc_status === '0' &&
                              item.playerinfo.score_pk !== null
                            ? 'status-standby'
                            : 'status-none',
                        ]"
                        @click="get_modal_handicap(item.playerinfo.playerno)"
                      >
                        {{
                          item.playerinfo.hc_status === "1"
                            ? $t("filter.common.done")
                            : item.playerinfo.hc_status === "0" &&
                              item.playerinfo.score_pk !== null
                            ? $t("filter.common.ready")
                            : $t("filter.common.none")
                        }}
                      </label>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="11" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <!-- <div class="col-9"> -->
        <b-pagination-nav
          :link-gen="linkGen"
          :number-of-pages="page_total"
          v-model="searchData.pageno"
          use-router
          :aria-label="$t('text.common.pagination')"
          v-if="page_total > 1"
          first-class="prev"
          prev-class="prev"
          next-class="next"
          last-class="next"
          hide-ellipsis
          limit="10"
        >
          <template #first-text>
            <i class="material-icons">keyboard_double_arrow_left</i>
          </template>
          <template #prev-text>
            <i class="material-icons">navigate_before</i>
          </template>
          <template #next-text>
            <i class="material-icons">navigate_next</i>
          </template>
          <template #last-text>
            <i class="material-icons">keyboard_double_arrow_right</i>
          </template>
          <template #page="{ page, active }">
            <div v-if="active">{{ page }}</div>
            <div v-else>{{ page }}</div>
          </template>
        </b-pagination-nav>
        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            :aria-label="$t('button.membership.excel_download')"
            @click="excelSave"
            >{{ $t("button.membership.excel_download") }}</b-button
          >
        </div>
        <!-- </div> -->
      </div>
    </div>
    <b-modal
      id="modal-handicap-reg"
      ref="modal-handicap-reg"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("page.membership.x_handicap") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-handicap-reg'].hide()"
        ></b-button>
      </template>
      <h6 class="modal-subtitle">{{ memberinfo.nickname }}'s Handicap</h6>

      <b-table-simple responsive class="scoreboard mb-4">
        <b-tbody v-if="handiscorecnt > 0">
          <b-tr>
            <!-- <b-th rowspan="4">{{ $t("title.common.player") }}</b-th> -->
            <b-th sticky-column>{{ $t("title.common.date") }}</b-th>
            <template v-for="(val, idx) in handiscore">
              <b-td
                :key="idx"
                :colspan="val.length"
                class="text-date text-nowrap"
                >{{
                  val[Object.keys(val)[0]].regdate | dateformat("YYYY-MM-DD")
                }}</b-td
              >
            </template>
          </b-tr>

          <b-tr>
            <b-th sticky-column>{{ $t("title.common.play_format") }}</b-th>
            <template v-for="(val, idx) in handiscore">
              <b-td :key="'c' + idx" :colspan="val.length"
                >{{ val[Object.keys(val)[0]].holecount }}H</b-td
              >
            </template>
          </b-tr>

          <b-tr>
            <b-th sticky-column>{{ $t("title.common.subcourse") }}</b-th>
            <template v-for="(val, idx) in handiscore">
              <template v-for="(val_, idx_) in val">
                <b-td
                  v-if="handiscore.length == idx + 1 && val.length == idx_ + 1"
                  :key="'d' + idx + idx_"
                  v-b-popover.hover.left="val_.title"
                  class="text-nowrap"
                >
                  {{ val_.description }}
                </b-td>
                <b-td
                  v-else
                  :key="'d' + idx + idx_"
                  v-b-popover.hover.top="val_.title"
                  class="text-nowrap"
                >
                  {{ val_.description }}
                </b-td>
              </template>
            </template>
          </b-tr>

          <b-tr>
            <b-th sticky-column>{{ $t("title.common.round") }}</b-th>
            <template v-for="(val, idx) in Array(handiscorecnt)">
              <b-td :key="'e' + idx"
                >{{
                  idx == 0
                    ? "Oldest"
                    : idx + 1 == handiscorecnt
                    ? "Newest"
                    : idx + 1
                }}
              </b-td>
            </template>
          </b-tr>
          <b-tr>
            <!-- <b-th>{{ memberinfo.nickname }}</b-th> -->
            <b-th sticky-column>{{ $t("title.common.score") }}</b-th>
            <template v-for="(val, idx) in handiscore">
              <template v-for="(val_, idx_) in val">
                <b-td :key="'f' + idx + idx_">
                  <span
                    :class="
                      handiscore_limit.find((v) => v.score_pk == val_.score_pk)
                        ? 'rounded-circle'
                        : ''
                    "
                    >{{ val_.score - val_.base_par }}
                  </span>
                </b-td>
              </template>
            </template>
          </b-tr>
        </b-tbody>
        <b-tbody v-else>
          <tr>
            <td class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </b-tbody>
      </b-table-simple>

      <div class="row g-3">
        <div class="col-sm-12 col-lg-6">
          <p class="mb-2 fw-500 fs-14 text-black">
            {{ $t("title.common.automation") }}
            {{ $t("title.common.handicap") }}
          </p>

          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="handicap_form.handicap_auto"
              readonly
            />
            <!-- <button
              class="btn btn-primary btn-lg icon-check"
              type="button"
              @click="
                handicap_form.handicap_index_ = hc_au(
                  handicap_form.handicap_auto
                )
              "
            >
              {{ $t("button.common.apply") }}
            </button> -->
          </div>
        </div>
        <div class="col-sm-12 col-lg-6">
          <p class="mb-2 fw-500 fs-14 text-black">
            {{ $t("title.common.activation") }}
            {{ $t("title.common.handicap") }}
          </p>
          <input
            type="text"
            v-model="handicap_form.handicap_index_"
            class="form-control"
            readonly
          />
        </div>

        <!-- <div class="col-sm-12 col-lg-4">
          <p class="mb-2 fw-500 fs-14 text-black">
            {{ $t("title.common.confirm_by") }}
          </p>

          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="handicap_form.writer"
            />
            <button
              class="btn btn-primary btn-lg icon-check"
              type="button"
              @click="set_playerhandicap(memberinfo.player_pk)"
            >
              {{ $t("button.common.confirm") }}
            </button>
          </div>
        </div> -->
        <p class="mt-2 text-subscript">
          {{ $t("text.membership.hc_base_9_hole") }}
        </p>
      </div>

      <template #modal-footer>
        <b-button
          type="button"
          class="btn btn-outline-secondary btn-md"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-handicap-reg'].hide()"
        >
          {{ $t("button.common.close") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/member";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "MemberList",
  data() {
    return {
      searchData: {
        membertype:
          this.$route.query.membertype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].membertype) ||
          0,
        status:
          this.$route.query.status ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].status) ||
          0,
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "P.player_id",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        pagesize:
          this.$route.query.pagesize ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pagesize) ||
          10,
        hc_status:
          this.$route.query.hc_status ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].hc_status) ||
          "",
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
      handiscore: [],
      handiscore_limit: [],
      handiscorecnt: 0,
      handicap_form: {
        handicap_index: 0,
        handicap_index_: 0,
        handicap_auto: 0,
        writer: this.$store.state.userId,
      },
      memberinfo: {
        player_pk: 0,
        id: "",
        nickname: "",
        firstname: "",
        lastname: "",
        email: "",
        membertype: "",
        timezone: "",
        daylighttime: "",
        gender: "",
        hand: "",
        teeheight: "",
        fieldunit: "",
        greenunit: "",
        speedunit: "",
        emailagree: "",
        status: "",
        handi_9: 0,
        handicap_index: 0,
        countryno: 0,
        statesno: 0,
      },
    };
  },
  watch: {
    "searchData.membertype": function () {
      this.searchData.pageno = 1;
      this.get_adminplayerlist();
    },
    "searchData.status": function () {
      this.searchData.pageno = 1;
      this.get_adminplayerlist();
    },
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.get_adminplayerlist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_adminplayerlist();
    },
    "searchData.hc_status": function () {
      this.searchData.pageno = 1;
      this.get_adminplayerlist();
    },
    "searchData.pageno": function () {
      this.get_adminplayerlist();
    },
    "searchData.pagesize": function () {
      this.searchData.pageno = 1;
      this.get_adminplayerlist();
    },
  },
  methods: {
    excelSave() {
      ax.excelSave(this.searchData, (body) => {
        let tab_text =
          '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
        tab_text +=
          '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
        tab_text +=
          "<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
        tab_text += "<x:Name>MemberList</x:Name>";
        tab_text +=
          "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
        tab_text += "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
        tab_text += "<table>";
        tab_text += body;
        tab_text += "</table></body></html>";

        var today = new Date();

        var year = today.getFullYear();
        var month = ("0" + (today.getMonth() + 1)).slice(-2);
        var day = ("0" + today.getDate()).slice(-2);

        var dateString = year + "-" + month + "-" + day;

        const fileName = "member".concat("_", dateString, ".xls");
        // const fileName = filename;
        const a_tag = document.createElement("a");
        const blob = new Blob([tab_text], {
          type: "application/vnd.ms-excel;charset=utf-8;",
        });
        a_tag.href = window.URL.createObjectURL(blob);
        a_tag.download = fileName;
        a_tag.click();
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;

      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_adminplayerlist();
    },
    get_adminplayerlist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_adminplayerlist(this.searchData, (flag, data) => {
        if (flag) {
          if (data.playerlistcnt <= 0) {
            this.data_yn = false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.playerlistcnt;
          this.page_total = Math.ceil(
            data.playerlistcnt / this.searchData.pagesize
          );
          this.items = data.playerlist;
        } else {
          this.data_yn = false;
          this.page_total = 0;

          alert(data.message);
        }
      });
    },
    get_modal_handicap(playerno) {
      this.$refs["modal-handicap-reg"].show();
      ax.get_adminplayerinfo(playerno, (flag, data) => {
        //console.log(flag, data);
        if (flag) {
          this.memberinfo = data.memberinfo;
          this.handicap_form.handicap_index = this.memberinfo.handicap_index;
          this.handicap_form.handicap_index_ = this.hc_au(
            this.memberinfo.handicap_index
          );

          this.handicap_form.handicap_auto = this.memberinfo.handi_9;
          this.handiscore = data.handiscore;
          this.handiscore_limit = data.handiscore_limit;
          this.handiscorecnt = data.handiscorecnt;

          // if (this.memberinfo.statesno) this.get_citylist();
        } else {
          alert(data);
        }
      });
    },
    set_playerhandicap(playerno) {
      this.handicap_form.handicap_index = this.strip_hc_au(
        this.handicap_form.handicap_index_
      );
      ax.set_playerhandicap(playerno, this.handicap_form, (flag, data) => {
        alert(data.message);
        this.$refs["modal-handicap-reg"].hide();
        //console.log(flag, data);
        if (flag) {
          this.get_adminplayerlist();
        } else {
          return false;
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  mounted() {
    this.get_adminplayerlist();
  },
  mixins: [myMixin],
};
</script>
<style scoped>
.active {
  color: #35383b;
}
</style>
